import 'regenerator-runtime';
import Vue from 'vue';
import App from './App.vue';
import './plugins/font-awesome';
import { safeHtml } from './common/directives/safe-html';

Vue.config.productionTip = false;
Vue.directive('safe-html', safeHtml);

new Vue({
  render: h => h(App),
}).$mount('#app');
